import { memo } from 'react';
import Script from 'next/script';
import { EnvironmentName } from '@hub/libs/constants';
import getNextConfig from 'next/config';
import type { NextRuntimeConfiguration } from '@hub/libs/config';
import { useFeatureFlag } from '@hub/libs/abby/abby';

const { publicRuntimeConfig } = getNextConfig() as NextRuntimeConfiguration;

const CadSearchScript = memo(() => {
  const showCadSearchButton = useFeatureFlag('showCadSearchButton');
  const scriptUrl = new URL('https://cus-kopla-integration.igusdev.igus.de/assets/inject-button.esm.js');

  const { envName } = publicRuntimeConfig;
  if (envName && envName === EnvironmentName.ORANGE) {
    scriptUrl.host = 'cad-search.igus.tools';
  }

  return showCadSearchButton ? (
    <Script
      data-testId="cad-search-script"
      type="text/javascript"
      id="cad-search"
      strategy="afterInteractive"
      src={scriptUrl.toString()}
    />
  ) : null;
});

export { CadSearchScript };
